import React from "react";
import styled from "styled-components";
import { CalculateButton } from "../CalculateButton";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 80px;
  align-items: center;
  box-sizing: border-box;
`;

const ControlItem = styled.div`
  padding-right: 10px;
  box-sizing: border-box;
`;

type Field = JSX.Element;

type Props = {
  fields: Field[];  
  onSelect: () => void;
  isCalculable: boolean;
};

export const DataEntryField = ({ fields, onSelect, isCalculable }: Props) => {
  return (
    <Container>
      <Container>
        {fields.map((field, index) => (
          <ControlItem key={index}>{field}</ControlItem>
        ))}
      </Container>
      <div onClick={() => isCalculable && onSelect()}>
        <CalculateButton actionable={isCalculable} />
      </div>
    </Container>
  );
};
